import React, { PureComponent } from "react";
import { UISref } from "@uirouter/react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { DefaultRowCell } from "../../../../Layout/SortedList";
import { checkIsInternalUser } from "../../../../../helpers/Authorization/authorizationHelpers";
import { formatQuantityValue } from "../../../../../helpers/unitOfMeasurementHelpers";
import { pushToBreadcrumbStack } from "../../../../../helpers/urlHelpers";
import DisplayFullDataButton from "../../../../Layout/SortedList/DisplayFullDataButton";

class ListRow extends PureComponent {
  static propTypes = {
    breadcrumbStack: PropTypes.array,
    customerId: PropTypes.string,
    isFullDataDisplayed: PropTypes.bool,
    isMobile: PropTypes.bool,
    item: PropTypes.object,
    onDisplayFullData: PropTypes.func
  };

  static defaultProps = {
    breadcrumbStack: [],
    customerId: "",
    isFullDataDisplayed: false,
    isMobile: false,
    item: {},
    onDisplayFullData: null
  };

  state = {
    hasOverflowedChild: false
  };

  handleOverflowedChildState = () => {
    this.setState({
      hasOverflowedChild: true
    });
  };

  render() {
    const { breadcrumbStack, customerId, isFullDataDisplayed, isMobile, item, onDisplayFullData } = this.props;
    const { hasOverflowedChild } = this.state;
    const { soldTo = {}, shipTo = {}, mills = [] } = item;
    const [firstMill = {}] = mills;
    const { location = {} } = firstMill;
    const isInternal = checkIsInternalUser();
    const updatedBreadcrumbStack = pushToBreadcrumbStack([...breadcrumbStack], "OrderPage");

    return (
      <UISref to="OrderPage" params={{ customerId, customerPOId: item.id, breadcrumbStack: updatedBreadcrumbStack }}>
        <div role="row" tabIndex="0" className={classNames("sorted-list__row", "--clickable", isFullDataDisplayed && "--full-data-displayed")}>
          <DefaultRowCell className="--first --x3" value={item.customerPOId} header={isMobile ? i18n.t("purchaseOrder.number") : ""} />
          {isInternal && <DefaultRowCell className="--x1" value={location.locationId} header={isMobile ? i18n.t("purchaseOrder.mill") : ""} />}
          <DefaultRowCell
            className="--x3"
            header={isMobile ? i18n.t("purchaseOrder.soldTo") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={soldTo.customerName}
          />
          <DefaultRowCell
            className="--x3"
            header={isMobile ? i18n.t("purchaseOrder.shipTo") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={shipTo.customerName}
          />
          <DefaultRowCell
            className="--x2"
            header={isMobile ? i18n.t("purchaseOrder.endUser") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={item.endUserId}
          />
          <DefaultRowCell
            className="--x2"
            header={isMobile ? i18n.t("purchaseOrder.poPeriod") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={item.pricingPeriodDate}
          />
          <DefaultRowCell
            className="--right --x2"
            header={isMobile ? i18n.t("purchaseOrder.ordered") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={formatQuantityValue(item.quantityAcknowledged)}
          />
          <DefaultRowCell
            className="--right --x2"
            header={isMobile ? i18n.t("purchaseOrder.shipped") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={formatQuantityValue(item.quantityShipped)}
          />
          <DefaultRowCell
            className="--right --x2"
            header={isMobile ? i18n.t("purchaseOrder.remaining") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={formatQuantityValue(item.quantityRemaining)}
          />
          {isMobile &&
            hasOverflowedChild && <DisplayFullDataButton isFullDataDisplayed={isFullDataDisplayed} onDisplayFullData={onDisplayFullData} />}
        </div>
      </UISref>
    );
  }
}

export default ListRow;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/ListPage/List/Tracking/ListRow.js